<template>
  <div class="home">
    <div class="home_ps">请在右上角通过浏览器打开，进行下载</div>
    <div class="btn_box">
      <div class="box_item" @click="android">
        <img src="../assets/icon1.png">
        android版下载
      </div>
      <div class="box_item" @click="iPhone">
        <img src="../assets/icon2.png">
        iPhone版下载
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
export default {
  name: 'Home',
  data(){
    return {
      projectType: null,  //1农贸城 2二手车 3好服务
      configData: [{
        name: '农贸城',
        androidUrl: 'http://114.55.146.47:8090/app/version/getVersion?content=%7B%22obj%22:%7B%22type%22:1%7D%7D',
        iosUrl: 'http://114.55.146.47:8090/web/download/getAppUrl'
      }, {
        name: '二手车',
        androidUrl: 'http://114.55.146.47:8093/app/version/getVersion?content=%7B%22obj%22:%7B%22type%22:1%7D%7D',
        iosUrl: 'http://114.55.146.47:8093/web/download/getAppUrl'
      }, {
        name: '好服务',
        androidUrl: 'http://47.96.131.222:8091/app/version/getVersion?content=%7B%22obj%22:%7B%22type%22:1%7D%7D',
        iosUrl: 'http://47.96.131.222:8091/web/download/getAppUrl'
      }]
    }
  },
  methods:{
    android(){
      let self = this
      axios({
        method:"GET",
        url: self.configData[parseInt(self.projectType) - 1].androidUrl,
        data: {},
        headers:{
          "Content-type":"multipart/form-data"
        },
        }).then(function (response) {
          window.open(response.data.data.url,"_self")
      })
    },
    iPhone(){
      let self = this
      axios({
        method:"GET",
        url: self.configData[parseInt(self.projectType) - 1].iosUrl,
        data: {},
        headers:{
          "Content-type":"multipart/form-data"
        },
        }).then(function (response) {
          window.open(response.data,"_self")
      })
    }
  },
  created() {
    this.projectType = this.$route.query.type
    if (this.projectType < 1 || !this.projectType) {
      alert('未获取到安装包类型')
    }
  },
}
</script>
<style lang="scss" scoped>
.home{
  width: 100%;
  height: 100%;
  background: url('../assets/bg.jpg') no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .home_ps{
    position: fixed;
    top: 10%;
    width: 100%;
    left: 0;
    text-align: center;
    font-size: 14px;
    color: #fff;
    font-weight: 600;
  }
  .btn_box{
    .box_item{
      width: 13.13rem;
      height: 2.8rem;
      background: hsla(0,0%,100%,.38);
      border: 0.04rem solid #fff;
      border-radius: 0.4rem;
      margin-bottom: 1.53rem;
      font-size: 14px;
      color: #fff;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        padding-right:2%;
        width: 10%;
      }
    }
  }
}
</style>
